import React from 'react'
import Messenger from '../components/Messenger';

function Chat() {
    return (
        <div>
            <Messenger />
        </div>
    )
}

export default Chat
